import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { API } from "../../../constants/apiPath";
import axios from "axios";
import { startLoading, stopLoading } from "../loader/loaderSlice";

const getAuthHeaders = () => {
  const token = localStorage.getItem("accessToken");

  return token
    ? { Authorization: `Bearer ${token}` }
    : {};
};

const initialState = {
  isLoading: false,
  orders: [],
  orderDetails: {}
};
const THUNK_METHODS = {
  ORDER_GET: "user/order",
  CREATE_ORDER: "user/createorder",
  ORDER_DETAILS: "user/order/id"
};




export const getUserOrders = createAsyncThunk(
  THUNK_METHODS.ORDER_GET,
  async (args, { dispatch, rejectWithValue }) => {
    try {
      dispatch(startLoading());

      const { data } = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}${API.ORDER.GET}`,
        withCredentials: true,
        headers: getAuthHeaders(),
      });

      return data.orders;
    } catch (error) {
      console.error(
        "GET USER ORDERS ERROR:",
        error.response?.data || error.message
      );

      return rejectWithValue(
        error.response?.data?.error || error.message
      );
    } finally {
      dispatch(stopLoading());
    }
  }
);


export const getOrderById = createAsyncThunk(
  THUNK_METHODS.ORDER_DETAILS,
  async (orderid,{ dispatch, rejectWithValue }) => {
    try {
      dispatch(startLoading());
      const {data} = await axios({
        method: "GET",
        url: `${process.env.REACT_APP_API_URL}${API.ORDER.GET}/${orderid}`,
        withCredentials: true,
                headers: getAuthHeaders(),

      });
      return data.order;
    } catch (error) {
      console.error(error.message);
      return rejectWithValue("Order by OrderID failed");
    } finally {
      dispatch(stopLoading());
    }
  }
);

export const orderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getUserOrders.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getUserOrders.fulfilled, (state, action) => {
      state.orders = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getUserOrders.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getOrderById.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getOrderById.fulfilled, (state, action) => {
      state.orderDetails = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getOrderById.rejected, (state) => {
      state.isLoading = false;
    });
  },
});
export const {  } = orderSlice.actions;
